import { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import moment from "moment";
import Swal from "sweetalert2";

const ConsolidatedReport = () => {
  const [data, setData] = useState([]);
  const fromRef = useRef(null);
  const toRef = useRef(null);
  const employeeIdRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [exams, setExams] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [maxQuestionLength, setMaxQuestionLength] = useState(0);
  const [selectedExam, setSelectedExam] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const headers = { access_token: token };

    const fetchData = async () => {
      try {
        const result = await Apiservice.ConsolidatedReportPage({ status: 0 }, headers);
        if (result.success === true) {
          const retrievedData = result.data;
          setExams(retrievedData);
        } else {
          alert(result.message || "Failed to fetch data.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("An error occurred while fetching the report.");
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    setData([]);
    if (!selectedExam) {
      setQuestions([]);
      setMaxQuestionLength(0);
      return;
    }
    const fetchData = async () => {
      try {
        exams.find((exam) => {
          if (exam.id == selectedExam) {
            setQuestions(exam.question)
            setMaxQuestionLength(exam.question.length);
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectedExam]);

  const validateForm = () => {
    const newErrors = {};
    if (!fromRef.current?.value.trim()) newErrors.from = "From Date is required";
    if (!toRef.current?.value.trim()) newErrors.to = "To Date is required";
    if (!selectedExam) newErrors.selectedExam = "Select Quiz Topic"
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchData = async () => {
    if (!validateForm()) return;

    const requestData = {
      from: fromRef.current.value,
      to: toRef.current.value,
      status: 0,
      employeeId: employeeIdRef.current?.value || "",
      examId: selectedExam
    };

    try {
      const token = localStorage.getItem("access_token");
      const headers = { access_token: token };
      const result = await Apiservice.Report(requestData, headers);

      if (result.success && Array.isArray(result.data)) {
        setData(result.data);
      } else {
        setData([]);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.message || "No data found!",
        });
      }
    } catch (err) {
      console.error(err);
      setData([]);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: '<a href="#">Why do I have this issue?</a>'
      });
    }
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const handleQuestionClick = (exam, index) => {
    const question = questions[index];

    if (!question) {
      Swal.fire("Missing", "Question not found for this index!", "info");
      return;
    }

    let optionsRaw = [];
    let selectedOption = "";

    try {
      optionsRaw = typeof question.options === "string"
        ? JSON.parse(question.options)
        : question.options;

      if (!Array.isArray(optionsRaw)) throw new Error("Options must be an array");

      // Extract selected option (last item)
      const last = optionsRaw[optionsRaw.length - 1];
      selectedOption = last?.selectedOption || "";
    } catch (err) {
      console.error("Failed to parse question options", err);
      Swal.fire("Error", "Invalid options format", "error");
      return;
    }

    // Extract actual 4 options (first 4 objects)
    const optionsHtml = optionsRaw.slice(0, 4).map((optObj, i) => {
      const key = `option${i + 1}`;
      const label = String.fromCharCode(65 + i); // A, B, C, D
      const text = optObj[key] || "-";
      const isCorrect = optObj.isCorrect;
      const isSelected = selectedOption === String(i + 1);

      // Styling
      let style = "padding:8px;margin-bottom:6px;border-radius:4px;";
      if (isCorrect && isSelected) {
        style += "background-color:#d1e7dd;border-left:4px solid #198754; font-weight: bold;";
      } else if (isCorrect) {
        style += "background-color:#e6ffed;border-left:4px solid #28a745;";
      } else if (isSelected) {
        style += "background-color:#e8f0fe;border-left:4px solid #007bff;";
      } else {
        style += "background-color:#f8f9fa;";
      }

      return `
      <div style="${style}">
        <strong>${label}.</strong> ${text}
      </div>
    `;
    }).join("");

    // Show in modal
    Swal.fire({
      title: `<strong>Question ${index + 1}</strong>`,
      html: `
      <div class="text-start">
        <p><b>Q:</b> ${question.question}</p>
        <p><b>Options:</b></p>
        ${optionsHtml}
      </div>
    `,
      confirmButtonText: "Close",
      customClass: {
        htmlContainer: 'text-start'
      }
    });
  };




  return (
    <div className="container-fluid p-2 shadow" style={{ backgroundColor: "#f8f9fa", userSelect: "none" }}>
      {/* Filter Form */}
      <div className="card p-3">
        <div className="row gy-2 gx-2 align-items-end">
          <div className="col-md-2">
            <label className="form-label form-label-sm">From</label>
            <input
              type="date"
              ref={fromRef}
              className={`form-control form-control-sm ${errors.from ? "is-invalid" : ""}`}
            />
            {errors.from && <div className="invalid-feedback">{errors.from}</div>}
          </div>
          <div className="col-md-2">
            <label className="form-label form-label-sm">To</label>
            <input
              type="date"
              ref={toRef}
              className={`form-control form-control-sm ${errors.to ? "is-invalid" : ""}`}
            />
            {errors.to && <div className="invalid-feedback">{errors.to}</div>}
          </div>
          <div className="col-md-3">
            <label className="form-label form-label-sm">Quiz</label>
            <select
              className={`form-select form-select-sm ${errors.to ? "is-invalid" : ""}`}
              value={selectedExam}
              onChange={(e) => setSelectedExam(e.target.value)}
            >
              <option value="">Select By Quiz</option>
              {exams.map((e, index) => (
                <option value={e.id} key={index}>{e.name}</option>
              ))}
            </select>
            {errors.selectedExam && <div className="invalid-feedback">{errors.selectedExam}</div>}
          </div>
          <div className="col-md-3">
            <label className="form-label form-label-sm">Employee ID</label>
            <input
              type="text"
              ref={employeeIdRef}
              className="form-control form-control-sm"
            />
          </div>
          <div className="col-md-2 d-flex">
            <button
              className="btn btn-primary btn-sm w-100"
              onClick={fetchData}
            >
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Profile Card */}
      <div className="row mt-4">
        <div className="col-12">
          {employeeIdRef.current?.value ? (
            <div className="card mb-4">
              <div className="card-body d-flex align-items-center">
                <img
                  src={data[0]?.userDetails?.[0]?.profileImage || ""}
                  alt="Profile"
                  className="rounded-circle me-3"
                  style={{ width: "80px", height: "80px", objectFit: "cover" }}
                />
                <div>
                  <h5 className="mb-1">
                    {`${data[0]?.userDetails?.[0]?.firstName || ""} ${data[0]?.userDetails?.[0]?.lastName || ""}`}
                  </h5>
                  <p className="mb-1 text-muted">{data[0]?.userDetails?.[0]?.emailId || ""}</p>
                  <p className="mb-0 text-muted">
                    {`${data[0]?.userDetails?.[0]?.countryCode || ""} ${data[0]?.userDetails?.[0]?.mobileNo || ""}`}
                  </p>
                </div>
              </div>
            </div>
          ) : null}

          {/* Table Section */}
          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  {!employeeIdRef.current?.value && <th>Emp. ID</th>}
                  {!employeeIdRef.current?.value && <th>Name</th>}
                  {Array.from({ length: maxQuestionLength }, (_, i) => (
                    <th key={i}>{`QA - ${i + 1}`}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? data.map((d, index) => {
                  const user = d.userDetails?.[0] || {};
                  const summary = d.summary ? JSON.parse(d.summary) : [];

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      {!employeeIdRef.current?.value && <td>{user.employeeId}</td>}
                      {!employeeIdRef.current?.value && <td>{`${user.firstName || ""} ${user.lastName || ""}`}</td>}
                      {Array.from({ length: maxQuestionLength }, (_, i) => {
                        const question = questions[i];
                        if (!question) {
                          return (
                            <td key={i} style={{ color: "gray", cursor: "pointer" }} onClick={() => handleQuestionClick(d, i)}>
                              --
                            </td>
                          );
                        }

                        // Match summary item by question_id
                        const answer = summary.find((s) => s.question_id === question.id);

                        if (!answer) {
                          return (
                            <td key={i} style={{ color: "gray", cursor: "pointer" }} onClick={() => handleQuestionClick(d, i)}>
                              --
                            </td>
                          );
                        }

                        const isCorrect = answer.isCorrect === 1;

                        return (
                          <td
                            key={i}
                            style={{ color: isCorrect ? "green" : "red", cursor: "pointer" }}
                            onClick={() => handleQuestionClick(d, i)}
                          >
                            {isCorrect ? "✔️" : "❌"}
                          </td>
                        );
                      })}

                    </tr>
                  );
                }) : (
                  <tr>
                    <td colSpan={maxQuestionLength + 3} className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsolidatedReport;
